import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IMessageSendEnmailListItem {
    id: string;
    email: string;
    modifyUser: IModifyUser;
    userCompanyName: string;
    userCompanyLogo: string;
    isRead: boolean;
}

export class MessageSendEnmailListItem implements IMessageSendEnmailListItem {
    id: string;
    email: string;
    modifyUser: ModifyUser;
    userCompanyName: string;
    userCompanyLogo: string;
    isRead: boolean;

    constructor();
    constructor(obj: IMessageSendEnmailListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.email = obj && obj.email || "";
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
        this.userCompanyName = obj && obj.userCompanyName || "";
        this.userCompanyLogo = obj && obj.userCompanyLogo || "";
        this.isRead = obj && obj.isRead || false;
    }
}